import { lazy } from 'react'
import { createBrowserRouter } from 'react-router-dom'
import { GuardAuth } from '~/components/Utils/GuardAuth'

const isDev = true // import.meta.env.DEV

const RelatedKeywordResultPage = lazy(() => import('~/pages/relatedKeyword/result'))
const CvResultPage = lazy(() => import('~/pages/cv/index'))
const ClinicReportsPage = lazy(() => import('~/pages/clinicReports/index'))
const AgeReportsPage = lazy(() => import('~/pages/ageReports/index'))
const MediaDailyAnalysisPage = lazy(() => import('~/pages/mediaDailyAnalysis/index'))
const MediaCorrelationAnalysisPage = lazy(() => import('~/pages/mediaCorrelationAnalysis/index'))
const MediaDailyDataPage = lazy(() => import('~/pages/mediaDailyData/index'))
const MediaWeeklyDataPage = lazy(() => import('~/pages/mediaWeeklyData/index'))
const MediaRulePage = lazy(() => import('~/pages/mediaRule/index'))
const MediaConditionGroupPage = lazy(() => import('~/pages/mediaConditionGroup/index'))
const GroupConditionCategoryPage = lazy(() => import('~/pages/groupConditionCategory/index'))
const AffiliateRewardPage = lazy(() => import('~/pages/affiliateReward/index'))
const B4aKpiSettingsPage = lazy(() => import('~/pages/b4aKpiSettings/index'))
const MeasuresPage = lazy(() => import('~/pages/measures/index'))
const FormAnalyticsPage = lazy(() => import('~/pages/formAnalytics/index'))
const LoginPage = lazy(() => import('~/pages/user/login'))
/**
 * App Routes
 *
 * ルーティングはこちらに記述します
 *
 * #### React Router v6
 * https://reactrouter.com/docs/en/v6
 *
 */
export function AppRoutes() {
  /* GuardAuth: ログインが必要なページ */
  return createBrowserRouter(
    [
      /* プロジェクト選択画面 */
      {
        path: '/',
        index: true,
        element: <GuardAuth children={<RelatedKeywordResultPage />} />,
      },
      {
        path: '/cv',
        index: true,
        element: <GuardAuth children={<CvResultPage />} />,
      },
      {
        path: '/clinic-reports',
        index: true,
        element: <GuardAuth children={<ClinicReportsPage />} />,
      },
      {
        path: '/age-reports',
        index: true,
        element: <GuardAuth children={<AgeReportsPage />} />,
      },
      {
        path: '/media-daily-analysis',
        index: true,
        element: <GuardAuth children={<MediaDailyAnalysisPage />} />,
      },
      {
        path: '/media-correlation-analysis',
        index: true,
        element: <GuardAuth children={<MediaCorrelationAnalysisPage />} />,
      },
      {
        path: '/media-daily-data',
        index: true,
        element: <GuardAuth children={<MediaDailyDataPage />} />,
      },
      {
        path: '/media-weekly-data',
        index: true,
        element: <GuardAuth children={<MediaWeeklyDataPage />} />,
      },
      {
        path: '/media-rule',
        index: true,
        element: <GuardAuth children={<MediaRulePage />} />,
      },
      {
        path: '/media-condition-group',
        index: true,
        element: <GuardAuth children={<MediaConditionGroupPage />} />,
      },
      {
        path: '/group-condition-category',
        index: true,
        element: <GuardAuth children={<GroupConditionCategoryPage />} />,
      },
      {
        path: '/affiliate-reward',
        index: true,
        element: <GuardAuth children={<AffiliateRewardPage />} />,
      },
      {
        path: '/b4a-kpi-settings',
        index: true,
        element: <GuardAuth children={<B4aKpiSettingsPage />} />,
      },
      {
        path: '/measures',
        index: true,
        element: <GuardAuth children={<MeasuresPage />} />,
      },
      {
        path: '/form-analytics',
        index: true,
        element: <GuardAuth children={<FormAnalyticsPage />} />,
      },
      {
        path: '/login',
        index: true,
        element: <LoginPage />,
      },
    ],
    {
      // CloudFront のルート直下に配信する（旧構成の /ads-dashboard/ サブパスは廃止）。
      basename: '/',
    }
  )
}
